import {
  UNASSIGNED,
  decodeTaskAssignee,
  encodeTaskAssignee,
} from '@/helpers/taskAssignee';
import { TaskTemplateAssignee } from '@payaca/types/entity-templates';

/**
 * A task template's assignee is a discriminated union; the pickers hold it as
 * a single string value (`user:<publicId>`, `team:<publicId>`, `projectOwner`,
 * `userCustomField:<identifier>`, or 'unassigned').
 *
 * A template can name everything a task can, plus two assignees resolved per
 * project at creation time. The variants it shares with a task are encoded by
 * the task codec, so an option value means the same thing in either picker.
 */
export const encodeAssignee = (
  assignee?: TaskTemplateAssignee | null
): string => {
  if (!assignee) return UNASSIGNED;
  switch (assignee.type) {
    case 'user':
    case 'team':
      return encodeTaskAssignee(assignee);
    case 'projectOwner':
      return 'projectOwner';
    case 'userCustomField':
      return `userCustomField:${assignee.customFieldIdentifier}`;
  }
};

export const decodeAssignee = (
  value?: string | null
): TaskTemplateAssignee | null => {
  if (!value || value === UNASSIGNED) return null;
  if (value === 'projectOwner') return { type: 'projectOwner' };

  const [kind, ...rest] = value.split(':');
  if (kind === 'userCustomField')
    return { type: 'userCustomField', customFieldIdentifier: rest.join(':') };

  return decodeTaskAssignee(value);
};
